import {Injectable} from '@angular/core';
import {Globals} from "../../global/globals";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {SharedService} from "../common/shared.service";
import {FormOptionsLists} from "../../shared/FormOptionsLists";
import {CanDoStatementEntry} from "../../dtos/can-do-statement/entry/can-do-statement-entry";
import {CanDoStatementEntryPage} from "../../dtos/can-do-statement/entry/can-do-statement-entry-page";
import {CanDoStatementEntryCreationDto} from "../../dtos/can-do-statement/entry/can-do-statement-entry-creation-dto";

@Injectable({
  providedIn: 'root'
})
export class GlobalCanDoStatementService {
  private globalCDStatementBaseUri: string = this.globals.backendUri + '/cds/global';

  formOptionsLists = new FormOptionsLists();

  constructor(private httpClient: HttpClient, private globals: Globals, private sharedService: SharedService) {
  }

  /* -------------------- entries -------------------- */

  // any necessary for service injection into generic table component
  searchEntries(params: HttpParams): Observable<any> {
    return this.httpClient.get<CanDoStatementEntryPage>(this.globalCDStatementBaseUri + '/entries', {params});
  }

  getEntry(id: number): Observable<any> {
    return this.httpClient.get<CanDoStatementEntry>(this.globalCDStatementBaseUri + '/entries/' + id);
  }

  createEntry(entry: CanDoStatementEntryCreationDto): Observable<CanDoStatementEntry> {
    return this.httpClient.post<CanDoStatementEntry>(this.globalCDStatementBaseUri + '/entries', entry);
  }

  updateEntry(id: number, entry: CanDoStatementEntryCreationDto): Observable<CanDoStatementEntry> {
    return this.httpClient.put<CanDoStatementEntry>(this.globalCDStatementBaseUri + '/entries/' + id, entry);
  }

  deleteEntry(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.globalCDStatementBaseUri + '/entries/' + id);
  }

  getEntryAsArray(entry: CanDoStatementEntry) {
    return cdsEntryAsArray(entry, this.sharedService, this.formOptionsLists);
  }
}

/**
 * Formats a can-do-statement entry into the [label, value][] structure the
 * generic EntryDetailsComponent renders. Shared by the global and detailed service.
 */
export function cdsEntryAsArray(entry: CanDoStatementEntry, sharedService: SharedService, formOptionsLists: FormOptionsLists) {
  const tmpEntries = sharedService.filterNullOrEmpty(sharedService.extractReferences(entry));
  const entries = [];
  for (const tmpEntry of tmpEntries) {
    if (tmpEntry[0] === 'id' || tmpEntry[0] === 'name') continue;
    if (tmpEntry[0] === 'receptive') {
      tmpEntry[0] = 'Niveau (rez.)';
    } else if (tmpEntry[0] === 'productive') {
      tmpEntry[0] = 'Niveau (prod.)';
    } else if (tmpEntry[0] === 'mode') {
      tmpEntry[0] = 'Modus';
      tmpEntry[1] = formOptionsLists.modesToString.get(tmpEntry[1]) ?? tmpEntry[1];
    } else if (tmpEntry[0] === 'activity') {
      tmpEntry[0] = 'Aktivität';
      tmpEntry[1] = formOptionsLists.activityToString.get(tmpEntry[1]) ?? tmpEntry[1];
    } else if (tmpEntry[0] === 'category') {
      tmpEntry[0] = 'Themenbaum';
      tmpEntry[1] = sharedService.getCategoryTree(tmpEntry[1]);
    }
    entries.push(tmpEntry);
  }
  return entries;
}
